import React from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner.jpg";
import notchbar from "../../assets/images/intro/notchbars.jpg";
import Cta from "../../components/common/Cta";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

const AluminiumNotchbar = () => {
    const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
    const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
    return (
        <div>
            <Helmet>
                <title>Aluminium Notchbar</title>
            </Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title={"Aluminium Notchbar"}
            />
            <div class="hero-layout container ptb-50">
                <div>
                    <div class="hero-badge">
                        <span></span>
                        In Stock — Ready for Bulk Dispatch
                    </div>
                    <h1>High-Purity<em>Aluminium Notch Bars </em>for Industry</h1>
                    <p class="hero-desc">
                       Manufactured from carefully recycled aluminium scrap through advanced melting and refining processes. Our notch bars deliver consistent alloy composition, minimal impurities, and reliable mechanical performance for demanding industrial applications.
                    </p>
                    <div class="hero-tags" aria-label="Product highlights">
                        <span class="tag">ADC12 Grade</span>
                        <span class="tag">A380 Grade</span>
                        <span class="tag">LM6 Grade</span>
                        <span class="tag">LM24 Grade</span>
                        <span class="tag">Custom Alloys</span>
                        <span class="tag">Bulk Supply</span>
                        <span class="tag">Pan-India Delivery</span>
                    </div>
                    <div class="hero-actions">
                        <a href="/contact" class="btn-primary">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>
                            Request a Quote
                        </a>
                        <a href="#specifications" class="btn-secondary">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14,2 14,8 20,8" /></svg>
                            View Datasheet
                        </a>
                    </div>
                </div>

                <div class="hero-visual">
                    <div class="product-visual-card">
                        <div class="visual-img">
                            <img src={notchbar} />
                        </div>

                        <div class="visual-stats">
                            <div class="stat-item">
                                <div class="stat-val"><em>As per requirement</em></div>
                                <div class="stat-label">Aluminium Purity</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-val"><em>As per requirement</em></div>
                                <div class="stat-label">Per Notch Bars Weight</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-val"><em>4+</em></div>
                                <div class="stat-label">Standard Grades</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-val">MT+</div>
                                <div class="stat-label">Bulk Supply</div>
                            </div>
                        </div>

                        <div class="avail-row">
                            <span class="avail-dot">Available in Stock | </span>
                            <span class="avail-note">Min. order: 1 MT</span>
                        </div>
                    </div>
                </div>
            </div>
            <section class="features-section container ptb-50" aria-labelledby="features-heading">
                <div class="section-header">
                    <p class="section-eyebrow">Why Our Notch Bars</p>
                    <h2 class="section-title" id="features-heading">Engineered for Aluminium Notch Bar Performance</h2>
                    <p class="section-sub">Our production process focuses on uniform alloy composition, superior purity, and precise dimensions — the three critical factors that ensure reliable performance for foundry and die-casting applications.</p>
                </div>
                <div class="features-grid">
                    <div class="feature-card" data-anim data-delay="1">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                        </div>
                        <div class="feature-title">Precise Alloy Composition Control</div>
                        <div class="feature-desc">State-of-the-art spectrometric testing at every melt ensures aluminium, silicon, and trace elements stay within strict tolerances, delivering consistent quality across every notch bar batch.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="2">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" /></svg>
                        </div>
                        <div class="feature-title">Enhanced Purity Assurance</div>
                        <div class="feature-desc">Our advanced degassing and flux refining methods eliminate hydrogen, oxides, and unwanted inclusions, resulting in clean, defect-free aluminium notch bars with excellent casting flow properties.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="3">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" /></svg>
                        </div>
                        <div class="feature-title">Reliable Bulk Supply Solutions</div>
                        <div class="feature-desc">Backed by high-capacity furnaces and a robust scrap sourcing system, we ensure steady and timely delivery of large-volume aluminium notch bar orders without compromising quality standards</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="4">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                        </div>
                        <div class="feature-title">Custom Aluminium Notch Bar Grades </div>
                        <div class="feature-desc">In addition to standard grades, we manufacture tailored aluminium notch bars designed to meet your exact chemical composition and performance requirements for specialized applications.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="5">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                        </div>
                        <div class="feature-title">Ahmedabad-Based Facility</div>
                        <div class="feature-desc">Situated in a prime industrial hub, our facility ensures seamless logistics, faster dispatch, and easy access to key automotive and foundry clusters for efficient supply chain management.</div>
                    </div>
                    <div class="feature-card" data-anim data-delay="6">
                        <div class="feature-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e07a2f" stroke-width="2"><path d="M12 3v1m0 16v1M4.22 4.22l.7.7m13.86 13.86l.7.7M1 12h2m18 0h2M4.22 19.78l.7-.7M18.64 5.36l.7-.7" /><circle cx="12" cy="12" r="4" /></svg>
                        </div>
                        <div class="feature-title">Eco-Responsible Process</div>
                        <div class="feature-desc">By utilizing recycled aluminium instead of primary production, we significantly reduce emissions while delivering eco-friendly notch bars that support your sustainability and ESG objectives.</div>
                    </div>
                </div>
            </section>
            <section class="specs-section container" id="specifications" aria-labelledby="specs-heading">
                <div class="section-header">
                    <p class="section-eyebrow">Datasheet</p>
                    <h2 class="section-title" id="specs-heading">Physical & chemical specifications</h2>
                </div>
                <div class="specs-layout">
                    <div class="spec-block" data-anim data-delay="1">
                        <div class="spec-block-head">Physical Properties</div>
                        <div class="spec-row">
                            <span class="spec-key">Form Factor</span>
                            <span class="spec-val">Standard Notch Bars</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Weight per Notch Bars</span>
                            <span class="spec-val highlight">As per requirement</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Density</span>
                            <span class="spec-val">2.65 – 2.70 g/cm³</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Melting Range</span>
                            <span class="spec-val">580°C – 660°C</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Surface Condition</span>
                            <span class="spec-val">Clean, Oxide-Free</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Packaging</span>
                            <span class="spec-val">Loose / Bundled</span>
                        </div>
                    </div>
                    <div class="spec-block" data-anim data-delay="2">
                        <div class="spec-block-head">Supply & Commercial</div>
                        <div class="spec-row">
                            <span class="spec-key">Minimum Order Quantity</span>
                            <span class="spec-val highlight">1 Metric Tonne</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Standard Supply Volume</span>
                            <span class="spec-val">1 MT – 100+ MT/month</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Dispatch Turnaround</span>
                            <span class="spec-val">24 – 48 hours</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Delivery Coverage</span>
                            <span class="spec-val">Pan-India (road & rail)</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Test Certificate</span>
                            <span class="spec-val">Available on Request</span>
                        </div>
                        <div class="spec-row">
                            <span class="spec-key">Custom Grades</span>
                            <span class="spec-val">Yes — 24 hr feasibility check</span>
                        </div>
                    </div>
                </div>
            </section>
            <Cta />
        </div>
    );
};

export default AluminiumNotchbar;
